import {defaultState} from './state';
import * as CookieUtils from '../../common/utils/CookieUtils';
import * as StateConstants from '../constants/StateConstants';
import * as LoginActions from '../actions/LoginActions';
import * as ProfileActions from '../actions/ProfileActions';

const login = (state = defaultState.login, action) => {

    switch (action.type) {
        case LoginActions.LOGIN_AND_REDIRECT_ACTION.name:
        case LoginActions.SET_REDIRECT_URL_ACTION.name: {
            // TODO sync expireTime with keycloak
            CookieUtils.setCookie(StateConstants.PATH_TO_REDIRECT, action.pathToRedirect, 1);
            return {
                ...state,
                pathToRedirect: action.pathToRedirect
            };
        }
        case LoginActions.LOGOUT_SUCCESS_ACTION.name:
        case ProfileActions.GOT_PROFILE_INFO_ACTION.name: {
            CookieUtils.deleteCookie(StateConstants.PATH_TO_REDIRECT);
            return {
                ...state,
                pathToRedirect: null
            };
        }
        default:
            return state;
    }
};

export default login;